export default __webpack_public_path__ + "static/media/greece.5bdf0c47.svg";